import { render, staticRenderFns } from "./mainPageBg.vue?vue&type=template&id=ab04e928&scoped=true&"
import script from "./mainPageBg.vue?vue&type=script&lang=js&"
export * from "./mainPageBg.vue?vue&type=script&lang=js&"
import style0 from "./mainPageBg.vue?vue&type=style&index=0&id=ab04e928&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab04e928",
  null
  
)

component.options.__file = "mainPageBg.vue"
export default component.exports